/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

import { atom } from "jotai";
import { BaseService } from "@/frameworks/libraries/restservice";

class PublicSpaceApproveRequest extends BaseService {
	constructor() {
		super();
	}

	private APIPath = (groupId: string) => `/api/groups/${groupId}/public_space_approve_requests`;

	private static Cache = {
		List: atom<WebServices.PublicSpaceApproveRequest.List.Response>({}),
		Process: atom<WebServices.PublicSpaceApproveRequest.Process.Response>({})
	};

	public list = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId }: WebServices.PublicSpaceApproveRequest.List.Request) => this.get(this.APIPath(groupId)),
		cache: PublicSpaceApproveRequest.Cache.List
	});

	public process = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ groupId, ...rest }: WebServices.PublicSpaceApproveRequest.Process.Request) =>
			this.post(this.APIPath(groupId), rest),
		cache: PublicSpaceApproveRequest.Cache.Process
	});
}

class PublicSpaceApproveRequestServiceStatic {
	constructor(public readonly psaRequest = new PublicSpaceApproveRequest()) {}
}

const PublicSpaceApproveRequestService = new PublicSpaceApproveRequestServiceStatic();
export default PublicSpaceApproveRequestService;
